import { render, staticRenderFns } from "./NavItemFlat.vue?vue&type=template&id=5df508a8&"
import script from "./NavItemFlat.vue?vue&type=script&lang=js&"
export * from "./NavItemFlat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports